module.exports = __webpack_public_path__ + "static/media/jason.c68ff912.png";